import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {IonicModule, IonicRouteStrategy, NavController} from '@ionic/angular';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {CountrySelectorComponent} from './views/common/components/modals/country-selector/country-selector.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LocationSelectorComponent} from './views/common/components/modals/location-selector/location-selector.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {SocketIoService} from './common/services/socket-io.service';
import {CustomerWelcomeComponent} from './views/customer/components/sliders/customer-welcome/customer-welcome.component';
import {BusinessWelcomeComponent} from './views/business/components/sliders/business-welcome/business-welcome.component';
import {HttpRequestsInterceptor} from './http-requests-interceptor';
import {StorageManagerGatewayCapacitor} from './adapters/real/app-services/storage-manager-gateway-capacitor';
import {UserGatewayHttp} from './adapters/real/api-services/gateways/user-gateway-http';
import {GetUserUseCase} from './core-logic/uses-cases/user/get-user-use-case';
import {StorageBusinessesManagerService} from './common/services/storage-businesses-manager.service';
import {StorageLoyaltiesCardsManagerService} from './common/services/storage-loyalties-cards-manager.service';
import {CustomModalComponent} from './views/common/components/modals/custom-modal/custom-modal.component';
import {SwiperModule} from 'swiper/angular';
import {GetAppVersionUseCase} from './core-logic/uses-cases/configuration/get-app-version-use-case';
import {ConfigurationGatewayHttp} from './adapters/real/api-services/gateways/configuration-gateway-http';
import moment from 'moment/moment';
import {NotificationManagerService} from './common/services/notification-manager.service';
import {NgChartsModule} from 'ng2-charts';
import {ColorPickerModule} from 'ngx-color-picker';
import {WheelSliceTypeModalComponent} from './views/business/components/modals/wheel-slice-type-modal/wheel-slice-type-modal.component';
import {ColorPickerModalComponent} from './views/business/components/modals/color-picker-modal/color-picker-modal.component';
import {SharedModule} from './shared-module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

moment.locale('fr');
@NgModule({
  declarations: [
    AppComponent,
    CountrySelectorComponent,
    LocationSelectorComponent,
    CustomerWelcomeComponent,
    BusinessWelcomeComponent,
    CustomModalComponent,
    WheelSliceTypeModalComponent,
    ColorPickerModalComponent
  ],
  entryComponents: [
    CountrySelectorComponent,
    LocationSelectorComponent,
    CustomerWelcomeComponent,
    BusinessWelcomeComponent,
    CustomModalComponent,
    WheelSliceTypeModalComponent,
    ColorPickerModalComponent
  ],
    imports: [
        BrowserModule,
        HttpClientModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        FormsModule,
        SwiperModule,
        NgChartsModule,
        ColorPickerModule,
        SharedModule,
        ReactiveFormsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: environment.production,
          // Register the ServiceWorker as soon as the application is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        })
    ],
  providers: [
    {
      provide: SocketIoService,
      useFactory: (navController: NavController, storageManagerGateway: StorageManagerGatewayCapacitor,
                   notificationManagerService: NotificationManagerService,
                   storageLoyaltiesCardsManagerService: StorageLoyaltiesCardsManagerService,
                   storageBusinessesManagerService: StorageBusinessesManagerService) =>
        new SocketIoService(navController, storageManagerGateway, notificationManagerService,
          storageLoyaltiesCardsManagerService, storageBusinessesManagerService),
      deps: [NavController, StorageManagerGatewayCapacitor, NotificationManagerService,
        StorageLoyaltiesCardsManagerService, StorageBusinessesManagerService]
    },
    {
      provide: StorageBusinessesManagerService, useFactory: (storageManagerGateway: StorageManagerGatewayCapacitor) =>
        new StorageBusinessesManagerService(storageManagerGateway),
      deps: [StorageManagerGatewayCapacitor]
    },
    {
      provide: GetUserUseCase,
      useFactory: (userGateway: UserGatewayHttp) => new GetUserUseCase(userGateway),
      deps: [UserGatewayHttp]
    },
    {
      provide: GetAppVersionUseCase,
      useFactory: (configurationGatewayHttp: ConfigurationGatewayHttp) => new GetAppVersionUseCase(configurationGatewayHttp),
      deps: [ConfigurationGatewayHttp]
    },
    {provide: HTTP_INTERCEPTORS, useClass: HttpRequestsInterceptor, multi: true},
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
